export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-chord/src/constant.js
// module id = 284
// module chunks = 0